import { render, staticRenderFns } from "./gods.vue?vue&type=template&id=6752edc8&scoped=true"
import script from "./gods.vue?vue&type=script&lang=ts"
export * from "./gods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6752edc8",
  null
  
)

export default component.exports